exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid-field-message {\n  padding: 5px; }\n  .invalid-field-message p {\n    margin: 0;\n    padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/error-display/error-display.component.scss
// module id = ../../../../../src/app/shared/error-display/error-display.component.scss
// module chunks = main